import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ProvisionApi } from 'api';
import type { Provision } from 'api/methods/ProvisionApi';

/**
 * [Provision] Query key 생성
 * --
 */
export const provisionQueryKeys = createQueryKeys('provision', {
  getProvision: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getProvisions: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Provision] 약관 전체 조회
 * --
 */
export const useGetProvisions = (
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: provisionQueryKeys.getProvisions(params).queryKey,
    queryFn: () => ProvisionApi.getProvisions(params),
    ...options,
  });
  return data;
};

/**
 * [Provision] 약관 상세 조회
 * --
 */
export const useGetProvision = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: provisionQueryKeys.getProvision(idx, params).queryKey,
    queryFn: () => ProvisionApi.getProvision(idx, params),
  });

  return data;
};

/**
 * [Provision] 약관 생성
 * --
 */
export const useCreateProvision = (body: Provision) => {
  const { mutateAsync: createProvision, ...result } = useMutation({
    mutationFn: (variables: Provision) =>
      ProvisionApi.createProvision(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createProvision, ...result };
};

/**
 * [Provision] 약관 수정
 * --
 */
export const useUpdateProvision = (body: Provision) => {
  const { mutateAsync: updateProvision, ...result } = useMutation({
    mutationFn: (variables: Provision) =>
      ProvisionApi.updateProvision(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateProvision, ...result };
};

/**
 * [Provision] 약관 삭제
 * --
 */
export const useDeleteProvision = (idx: number) => {
  const { mutateAsync: deleteProvision, ...result } = useMutation({
    mutationFn: (variables: number) => ProvisionApi.deleteProvision(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteProvision, ...result };
};
